import isTruthy from './isTruthy';
import type { IndexSpec } from './models/indexes';

export default function id(item: { db: string; coll?: string; name?: string; spec?: IndexSpec }): string {
  return [item.db, item.coll, item.name ?? item.spec?.name].filter(isTruthy).join('/');
}
